import { polarisProductGlobalViewsSettingsEntryPoint } from '@jira/spa-apps__polaris-settings-global-views/polarisProductGlobalViewsSettingsEntryPoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const polarisProductGlobalViewsSettingsPageEntry = createPageEntryPoint({
	main: polarisProductGlobalViewsSettingsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});
